import { render, staticRenderFns } from "./PublicTable1.vue?vue&type=template&id=2ce9d388"
import script from "./PublicTable1.vue?vue&type=script&lang=ts"
export * from "./PublicTable1.vue?vue&type=script&lang=ts"
import style0 from "./PublicTable1.vue?vue&type=style&index=0&id=2ce9d388&prod&lang=scss&scpoed=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports